import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'components/ui/collapse';
import { CardHeader, Button, Card, CardBody, CardFooter } from 'components/ui';

const Panel = ({ children, title, collapse, collapsable, titleActions, titleExtension, className, bodyClassName, footer, noHeader, ...rest }) => {
  const [isCollapsed, setIsCollapsed] = useState(collapse);
  useEffect(() => {
    if (collapse !== isCollapsed) {
      setIsCollapsed(collapse);
    }
  }, [collapse]);
  return (
    <Card className={className} {...rest}>
      {!noHeader && (
        <CardHeader
          titleExtension={titleExtension}
          title={title || ''}
          beforeTitle={
            collapsable && (
              <Button
                className="mr-1"
                size="sm"
                color="light"
                iconClassName={isCollapsed ? 'icon-rotate-270' : ''}
                onClick={() => {
                  return setIsCollapsed(!isCollapsed);
                }}
                icon="arrow-down"
              />
            )
          }
        >
          {titleActions}
        </CardHeader>
      )}
      <Collapse isOpen={!isCollapsed}>
        <CardBody className={bodyClassName}>{children}</CardBody>
      </Collapse>
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  );
};

Panel.defaultProps = {
  collapse: false,
  collapsable: false,
  titleActions: null,
};

Panel.propTypes = {
  children: PropTypes.any.isRequired,
  title: PropTypes.any,
  titleActions: PropTypes.any,
  collapse: PropTypes.bool,
  collapsable: PropTypes.bool,
};

export default Panel;
